import { useEffect, useId, useState } from "react"

import { FilterSelect } from "@/components/shared/filter-select"
import { Card, CardContent } from "@/components/ui/card"
import { Input } from "@/components/ui/input"
import { PAGE_SIZE_OPTIONS } from "@/routes/_authed/_admin/guild-events.index"

type SearchSchema = {
  status?: string
  bucket?: string
  query?: string
  page?: number
  pageSize?: number
}

export function EventListFilters({
  status,
  bucket,
  query,
  pageSize,
  onNavigate,
}: {
  status: string
  bucket: string
  query: string
  pageSize: number
  onNavigate: (updater: (prev: SearchSchema) => Partial<SearchSchema>) => void
}) {
  const [draft, setDraft] = useState(query)
  const searchId = useId()
  useEffect(() => {
    setDraft(query)
  }, [query])
  useEffect(() => {
    const t = setTimeout(() => {
      onNavigate((prev) => ({
        ...prev,
        query: draft.trim() || undefined,
        page: 1,
      }))
    }, 250)
    return () => clearTimeout(t)
  }, [draft, onNavigate])
  return (
    <Card>
      <CardContent className="grid gap-3 pt-5 md:grid-cols-[1.2fr_0.8fr_0.8fr_auto] md:items-end">
        <div className="grid gap-2">
          <label
            htmlFor={searchId}
            className="text-xs font-semibold tracking-wide text-muted-foreground uppercase"
          >
            Search
          </label>
          <Input
            id={searchId}
            value={draft}
            placeholder="Title or description"
            onChange={(event) => setDraft(event.target.value)}
          />
        </div>
        <FilterSelect
          label="Status"
          value={status}
          options={[
            ["all", "All statuses"],
            ["scheduled", "Scheduled"],
            ["closed", "Closed"],
            ["started", "Started"],
            ["cancelled", "Cancelled"],
            ["announcement_missing", "Announcement Missing"],
          ]}
          onChange={(next) => {
            onNavigate((prev) => ({
              ...prev,
              status: next === "all" ? undefined : next,
              page: 1,
            }))
          }}
        />
        <FilterSelect
          label="Time"
          value={bucket}
          options={[
            ["active", "Active"],
            ["all", "All"],
            ["upcoming", "Upcoming"],
            ["past", "Past"],
          ]}
          onChange={(next) => {
            onNavigate((prev) => ({
              ...prev,
              bucket: next,
              page: 1,
            }))
          }}
        />
        <FilterSelect
          label="Page size"
          value={String(pageSize)}
          options={PAGE_SIZE_OPTIONS.map(
            (n) => [String(n), String(n)] as [string, string],
          )}
          onChange={(next) => {
            onNavigate((prev) => ({
              ...prev,
              pageSize: Number(next),
              page: 1,
            }))
          }}
        />
      </CardContent>
    </Card>
  )
}
